<template>
  <div class="text">
      <template v-if="Index<60">
        <template v-for="(item, index) in 50">
            <img v-show="Index%60==index" :src="require('../../assets/images/text/'+index+'.png')" :key="index" alt="">
        </template>
      </template>
      <img v-show="Index>=50" :src="require('../../assets/images/text/'+50+'.png')" alt="">
  </div>
</template>

<script>
export default {
  components:{},
  props:['Index'],
  data(){
    return {
        
    }
  },
  watch:{},
  computed:{},
  methods:{},
  created(){
      
  },
  mounted(){}
}
</script>
<style scoped>
.text{
  position: absolute;
  top: 9rem;
  left: 2rem;
  width: 5rem;
  height: 3rem;
  z-index: 50;
}
.text img{
   
    width: 100%;
    height: 100%;
}
</style>